import { defineStore } from "pinia";
import { ref } from "vue";

export const useSubmitLessonValidationStore = defineStore("submitLessonValidation", () => {
  const submissionValidationErrors = ref({});

  const getSubmissionValidationErrors = () => {
    return submissionValidationErrors.value;
  };
  const setSubmissionValidationErrors = (submissionValidationErrors) => {
    submissionValidationErrors.value = submissionValidationErrors;
  };
  const resetSubmitErrors = () => {
    submissionValidationErrors.value = {};
  };
  const removeSubmitErrors = (errorName) => {
    const newErrors = Object.assign({}, submissionValidationErrors.value);
    delete newErrors[errorName];
    submissionValidationErrors.value = newErrors;
  };
  const addSubmissionValidationErrors = (validationError) => {
    const newErrors = Object.assign({}, submissionValidationErrors.value);
    newErrors[validationError.errorName] = validationError.message;
    submissionValidationErrors.value = newErrors;
  };

  return {
    getSubmissionValidationErrors,
    setSubmissionValidationErrors,
    resetSubmitErrors,
    removeSubmitErrors,
    addSubmissionValidationErrors,
  };
});
